module.exports = __webpack_public_path__ + "img/sounding-p.f21f95f8.jpg";